import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { formatPremiumLimits } from '../utils/getPremiumLimits'
import type { ResourceUsage } from '@wix/ambassador-cloud-resourceusage-v1-resource-usage/types'

export const onPremiumLimitsChange = (
  editorSdkProxy: EditorSDK,
  payload: ResourceUsage,
): void => {
  editorSdkProxy.editor.updateAppState({
    premiumLimits: formatPremiumLimits(payload),
  })
}
